import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-checkmark-02',
	templateUrl: './icon-checkmark-02.component.svg',
})
export class IconCheckmark02Component {}
